import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import History from "../History/History";
import FAQ from "../../components/FAQ";
import GoogleButton from "../../auth/GoogleAuth";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { analytics } from "../../firebase/firebase";
import { logEvent } from "firebase/analytics";
import { config } from "../../config/config";
import { useRef } from "react";
import Tabbuttons from "../../components/TabButtons";
import imageSrc from "../../assets/upgradetopro.png";
import { useSearchParams } from 'react-router-dom';
import Youtubebutton from "../../components/YouTubePostButton";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import HamburgerOverlay from "../../components/HamburgerOverlay";
import LeftPanel from "../../components/LeftPanel";
import NotificationBar from "../../components/NotificationBar";
import { 
  trackPageView, 
  trackEvent, 
  trackSessionStart, 
  trackSessionEnd 
} from '../../utils/analyticsService';
import Loader from "../../components/Loader";
function App() {
  const [activeTab, setActiveTab] = useState("write");
  const [isOpen, setIsOpen] = useState(false);
   const [searchParams] = useSearchParams(); 
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({}); 
  const subscriptionStatus = JSON.parse(
    localStorage.getItem("subscriptionStatus")
  );
  const googleanalytics = process.env.REACT_APP_GOOGLE_ANALYITCS_ID;
  const [isButtonVisible, setIsButtonVisible] = useState(true);

  const [generatedResult, setGeneratedResult] = useState("");
const [showAdvanced, setShowAdvanced] = useState(false);

 

    useEffect(() => {
    const params = new URLSearchParams(location.search);
    const isHistory = params.get('history') === 'true';

    if (isHistory) {
      setActiveTab('history');

    
      navigate('/Dashboard', { replace: true });
    }
  }, [location.search, navigate]);
    const [artStyle, setArtStyle] = useState("anime");
    const googleAuthRef = useRef(null);
    const [prompt, setprompt] = useState("");
    const [selectduration, setselectduration] = useState("30");
    const [selectlanguage, setselectlanguage] = useState("english");
    const [selectfontcolor, setselectfontcolor] = useState("White");
    const [selectvideoType, setselectvideoType] = useState("explainervideo");
    const [selectmediaType, setselectmediaType] = useState("no");
    const [selectTextStyle, setSelectTextStyle] = useState("Default");
    const [selectStyleColor, setSelectStyleColor] = useState("Black"); 
    const [useCustomFont, setUseCustomFont] = useState(false);
    const [selectsize, setselectsize] = useState("9:16");
  const [selectVoice, setselectVoice] = useState("None");
    //Notificaion
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState("");
    const [notificationType, setNotificationType] = useState("error");

    const triggerNotification = (message) => {
      setNotificationMessage(message);
      setShowNotification(true);
    };

    React.useEffect(() => {
      document.documentElement.style.setProperty("--main-color", config.color);
    }, [config.color]);

    const toggleOverlay = () => setIsOpen((prev) => !prev);

    useEffect(() => {
      document.body.style.overflow = isOpen ? "hidden" : "auto";
      return () => {
        document.body.style.overflow = "auto";
      };
    }, [isOpen]);

    const handleLoginSuccess = (userProfile) => {
      if (userProfile) {
        logEvent(analytics, "Login_btn_clicked__FacelessVideo", {
          button_name: "login_button_FacelessVideo",
        });
      } else {
      }
    };

    const handleLoginFailure = (error) => {
      if (error.error) {
        alert(`Login failed: ${error.error}`);
      } else {
      }
    };


    

  function buildGeneratePayload({
    prompt,
    selectvideoType,
    selectmediaType,
    selectduration,
    selectlanguage,
    selectsize,
    useCustomFont,
    selectfontcolor,
    selectTextStyle,
    selectStyleColor,
    currentSong,
    selectVoice,
    artStyle  
  }) {
    return {
      Prompt: prompt,
      Category: selectvideoType,
      aiMedia:selectmediaType,
      art_style: selectmediaType === "yes" ? artStyle : "anime",
      Duration: selectduration,
      selectedlanguage:selectlanguage,
      size: selectsize,
      Music: currentSong ? currentSong.file : "none",
      Font: useCustomFont,
      FontColor: selectfontcolor,
      TextStyle: selectTextStyle,
      StyleColor: selectStyleColor,
      voice_over: selectVoice,
    };
  }

  // 1b) The actual fetch+redirect logic
  async function performGenerate(requestBody, { toast, config, triggerNotification }) {
    const res = await fetch(`${config.baseURL}/generation/request_place.php`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    const data = await res.json();

    // Handle failure responses
    if (!data.status || data.status !== "success") {
      if (data.message?.includes("Authentication")) {
        throw new Error("AUTH_REQUIRED");
      }

      if (data.message?.includes("Usage limit exceeded")) {
        window.location.href = "/premium?reason=limit";
        return;
      }

      triggerNotification(data.message || "An unexpected error occurred!");
      throw new Error("GEN_FAIL");
    }

    toast.success("Processing... please wait");

    // Start polling with returned ID
    const jobId = data.Id;
    await pollStatusUntilComplete(jobId, {
      toast,
      config,
      triggerNotification,
      narratorText: data.story,
      recordId: jobId,
    });
  }

  async function pollStatusUntilComplete(jobId, {
    toast,
    config,
    triggerNotification,
    narratorText,
    recordId
  }) {
    const maxAttempts = 15; // Prevent infinite loop
    let attempts = 0;

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    console.log(`[Poll] Starting polling for jobId=${jobId}...`);

    while (attempts < maxAttempts) {
      console.log(`[Poll] Attempt ${attempts + 1} of ${maxAttempts}`);

      await delay(20000);
      attempts++;

      let statusData;
      try {
        const res = await fetch(
          `${config.baseURL}/generation/media_status.php?id=${jobId}`,
          {
            method: "POST",
            credentials: "include",
          }
        );

        try {
          statusData = await res.json();
        } catch (jsonErr) {
          console.error("[Poll] Failed to parse JSON:", jsonErr);
          continue; // Skip to next attempt
        }
      } catch (fetchErr) {
        console.error("[Poll] Fetch error:", fetchErr);
        continue; // Skip to next attempt
      }

      console.log("[Poll] Got status:", statusData);

      if (statusData?.status === "completed") {
        console.log("[Poll] Job completed, redirecting...");
        toast.success("Video generation completed!");
        const videoUrl = encodeURIComponent(statusData.video_url);
       const newId = encodeURIComponent(recordId);

        window.location.href = `/result?recordId=${newId}&videoUrl=${videoUrl}&edited=0`;
        return;
      }

      if (
        statusData?.status === "failed" ||
        statusData?.status === "error"
      ) {
        console.warn("[Poll] Job failed or errored:", statusData);
        triggerNotification("Video generation failed. Please try again.");
        throw new Error("GEN_FAIL");
      }

      // Otherwise still processing
      toast.info(`Status: ${statusData?.message || "Processing..."}`);
    }

    console.warn("[Poll] Reached max attempts without completion.");
    triggerNotification("Video is taking too long. Please check back later.");
    throw new Error("TIMEOUT");
  }



const onLoginSuccess = () => {
  if (!sessionStorage.getItem('shownLoginToast')) {
  toast.success(`Login complete`);
  sessionStorage.setItem('shownLoginToast', 'true');
}

  const pending = sessionStorage.getItem("pendingGenerate");
if (pending) {
  const requestBody = JSON.parse(pending);

  // **SHOW** loader again
  setIsLoading(true);

  performGenerate(requestBody, { toast, config, triggerNotification })
    .then(() => {
      sessionStorage.removeItem("pendingGenerate");
    })
    .catch((err) => {
     sessionStorage.removeItem("pendingGenerate");
    })
    .finally(() => {
     sessionStorage.removeItem("pendingGenerate");
      setIsLoading(false);
    });
}
};


const handleGenerate = async () => {
  setErrors({});

  // 1️⃣ Validate prompt
  if (!prompt.trim()) {
    setErrors({ prompt: "Prompt is required" });
    triggerNotification("Prompt cannot be empty.");

    const promptElement = document.getElementById("prompt");
    if (promptElement) {
      promptElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    setTimeout(() => setErrors({}), 4000);
    return;
  }

  // 2️⃣ Prepare payload
  const requestBody = buildGeneratePayload({
    prompt,
    selectvideoType,
    selectmediaType,
    selectduration,
    selectlanguage,
    selectsize,
    useCustomFont,
    selectfontcolor,
    selectTextStyle,
    selectStyleColor,
    currentSong,
    selectVoice,
    artStyle  
  });

  // 3️⃣ Store payload (in case user logs in mid-process)
  sessionStorage.setItem("pendingGenerate", JSON.stringify(requestBody));

  // 4️⃣ Show loader + try generate
  setIsLoading(true);

  try {
    await performGenerate(requestBody, { toast, config, triggerNotification });
    sessionStorage.removeItem("pendingGenerate");
  } catch (err) {
    if (err.message === "AUTH_REQUIRED") {
      triggerNotification("Please login!");
      googleAuthRef.current.login();
    } else {
      triggerNotification("Video generation failed.");
    }
  } finally {
    setIsLoading(false); // hide loader after success or failure
  }
};

  const [songs, setSongs] = useState([]);
  const [currentSong, setCurrentSong] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const audioPlayer = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const songList = [
      {
        name: "Synthwave goose-blade runner 2049",
        file: "Synthwavegoose-bladerunner2049",
      },
      { name: "Not Responsible (Slowed)", file: "NotResponsible(Slowed)" },
      {
        name: "FrankJavCee - Simpsonwave 1995",
        file: "FrankJavCee-Simpsonwave1995",
      },
      {
        name: "INTERWORLD - METAMORPHOSIS",
        file: "INTERWORLD-METAMORPHOSIS",
      },
      { name: "WINDOWS 95", file: "WINDOWS95" },
    ];
    setSongs(songList);
  }, []);

  const togglePlayPause = (song, event) => {
    event.stopPropagation();

    if (currentSong && currentSong.file !== song.file) {
      stopMusic();
    }

    if (audioPlayer.current.paused) {
      audioPlayer.current.src = `/Music/${song.file}`;
      audioPlayer.current.play();
      setCurrentSong(song);
      setPlaying(true);
      logEvent(analytics, "Music played on faceless video app ", {
        component_name: "CreateContent",
        videoUrl: song.file,
      });
    } else {
      audioPlayer.current.pause();
      setPlaying(false);
    }
  };

  const stopMusic = () => {
    if (audioPlayer.current) {
      audioPlayer.current.pause();
      setPlaying(false);
      setCurrentSong(null);
    }
  };
  const stopselectedSong = () => {
    if (audioPlayer.current) {
      audioPlayer.current.pause();
      setPlaying(false);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      const handleSongClick = (song) => {
        setCurrentSong(song);
        setDropdownOpen(false);
        stopselectedSong();
      };
    }
  };

  const handleSongClick = (song) => {
    setCurrentSong(song);
    setDropdownOpen(false);
    stopselectedSong();
  };

  // Handle 'No Music' selection
  const handleNoMusicClick = () => {
    setCurrentSong(null);
    setDropdownOpen(false);
    stopMusic();
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const colorOptions = [
    "Black",
    "White",
    "Red",
    "Green",
    "Blue",
    "Yellow",
    "Cyan",
    "Magenta",
    "Gray",
    "Orange",
  ];

  const stylesWithColor = new Set([
    "Text With Border",
    "Text Inside Dark Box",
    "Text Inside Light Box",
  ]);


  return (
    <HelmetProvider>
      <div className="App">
        <Helmet>
          <title> Create Text to Video | Generator.Video</title>
          <meta
            name="description"
            content="Create stunning AI-generated videos effortlessly with Generator.Video. Transform text into high-quality videos with advanced AI technology. No editing skills required – just input your text and let AI do the rest!"
          />
          <meta
            name="keywords"
            content="AI video generator, text to video, AI-powered video creation, create AI videos, automatic video generator, text-based video creation, AI video editing, video content creation, Generator.Video"
          />

          <link rel="canonical" href="https://generator.video/Dashboard" />
        </Helmet>
        <div className="header_mobile">
          <img
            src={config.hamburger}
            alt="Menu"
            className="hamburger"
            onClick={toggleOverlay}
          />
          <div className="login_crown_container">
            <Link to="/premium">
              <img src={config.crown} alt="Crown" />
            </Link>

            <GoogleButton
              ref={googleAuthRef}
              id="logout_header"
              onLoginSuccess={onLoginSuccess}
              onLoginFailure={handleLoginFailure}
            />
          </div>
        </div>
        {(subscriptionStatus !== "ACTIVE" || !subscriptionStatus) &&
          isButtonVisible && (
            <Link to="/premium">
              <div className="floating-button">
                <img src={imageSrc} alt="Floating Button" />
              </div>
            </Link>
          )}
        <HamburgerOverlay
          isOpen={isOpen}
          toggleOverlay={toggleOverlay}
          config={config}
          GoogleButton={GoogleButton}
          handleLoginSuccess={handleLoginSuccess}
          handleLoginFailure={handleLoginFailure}
          googleAuthRef={googleAuthRef}
        />
        <div id="container">
          <LeftPanel />
          <div className="main_panel">
            <div className="title_main_page">
              <Link to="/">
                <button className="back-button-dashboard">
                  <img
                    className="back-button-dashboard"
                    src={config.Backbutton}
                    alt="Back"
                  />
                </button>
              </Link>

              <h1 className="title_name">
                {config.title}{" "}
                {subscriptionStatus === "ACTIVE" && (
                  <img src={config.proicon} alt="" className="proicon" />
                )}
              </h1>
            </div>

            <Tabbuttons
              activeTab={activeTab}
              onTabChange={setActiveTab}
              analytics={analytics}
            />

            {activeTab === "write" && (
              <>
                <div className="form">
                  <div className="form-group" style={{ gridColumn: "span 2" }}>
                    <div className="topic" id="propmt">Prompt/Story </div>
                    <textarea
                      className={`input_1 ${errors.prompt ? "error" : ""}`}
                      placeholder={config.ContentTopic}
                      value={prompt}
                      onChange={(e) => setprompt(e.target.value)}
                      maxLength="1000"
                    />
                    {errors.prompt && (
                      <div className="error-message">{errors.prompt}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <div className="topic">Select Media </div>
                    <select
                      className="input_3"
                      name="tone"
                      value={selectmediaType}
                      onChange={(e) => setselectmediaType(e.target.value)}
                    >
                      <option value="no">Stock Media</option>
                      <option value="yes">Ai generated</option>
                    </select>
                  </div>

                   <div className="form-group">
                    <div className="topic">Caption</div>
                    <select
                      className="input_3"
                      name="font"
                      value={useCustomFont.toString()} 
                      onChange={(e) => setUseCustomFont(e.target.value === "true")}
                    >
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </select>
                  </div>

                     <div className="form-group">
                    <div className="topic">Select langauge</div>
                    <select
                      className="input_3"
                      name="tone"
                      value={selectlanguage}
                      onChange={(e) => setselectlanguage(e.target.value)}
                    >
                      <option value="english">English</option>
                      <option value="hindi">Hindi</option>
                      <option value="spanish">Spanish</option>
                      <option value="french">French</option>
                      <option value="german">German</option>
                      <option value="italian">Italian</option>
                      <option value="portuguese">Portuguese</option>
                      <option value="russian">Russian</option>
                      <option value="chinese">Chinese</option>
                      <option value="japanese">Japanese</option>
                      <option value="korean">Korean</option>
                      <option value="arabic">Arabic</option>
                    </select>
                  </div>

                   <div className="form-group">
                    <div className="topic">Select Duration</div>
                    <select
                      className="input_3"
                      name="tone"
                      value={selectlanguage}
                      onChange={(e) => setselectduration(e.target.value)}
                    >
                      <option value="30">30 seconds</option>
                      <option value="45">45 seconds</option>
                      <option value="60">60 seconds</option>
                    </select>
                  </div>


                    <div className="form-group">
                    <div className="topic">Select Voice Over </div>
                    <select
                      className="input_3"
                      name="tone"
                      value={selectVoice}
                      onChange={(e) => setselectVoice(e.target.value)}
                    >
                      <option value="none">None</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>


<div className="form-group">
                    <div className="topic">Advanced Settings</div>
<button
  type="button"
  className="input_3"
  onClick={() => setShowAdvanced(!showAdvanced)}
>
  {showAdvanced ? "Hide" : "Show"}
</button>
</div>


{showAdvanced && (
  <>
                   <div className="form-group">
                    <div className="topic">Select Video Type </div>
                    <select
                      className="input_3"
                      name="tone"
                      value={selectvideoType}
                      onChange={(e) => setselectvideoType(e.target.value)}
                    >
                      <option value="explainervideo">Explainer Video</option>
                      <option value="tutorialvideo">Tutorial</option>
                      <option value="product-demo">Product Demo</option>
                      <option value="testimonial">Testimonial</option>
                      <option value="social-media">Social Media Video</option>
                      <option value="promo">Promotional Video</option>
                      <option value="live-action">Live Action Video</option>
                    </select>
                  </div>

                 
                {showAdvanced && selectmediaType === "yes" && (
  <div className="form-group">
    <div className="topic">Select Art Style</div>
    <select
      className="input_3"
      value={artStyle}
      onChange={(e) => setArtStyle(e.target.value)}
    >
      <option value="anime">Anime</option>
      <option value="ttv_cinematic_v2">TTV Cinematic V2</option>
      <option value="film_noir">Film Noir</option>
      <option value="3d_toon">3D Toon</option>
      <option value="watercolor">Watercolor</option>
      <option value="expressionism">Expressionism</option>
      <option value="charcoal">Charcoal</option>
      <option value="gtav">GTAV</option>
      <option value="creepy_toon">Creepy Toon</option>
      <option value="childrens_book">Children's Book</option>
      <option value="photo_realism">Photo Realism</option>
      <option value="minecraft">Minecraft</option>
      <option value="comic_book">Comic Book</option>
      <option value="disney_toon">Disney Toon</option>
      <option value="studio_ghibli">Studio Ghibli</option>
      <option value="pixelated">Pixelated</option>
      <option value="ttv_cinematic">TTV Cinematic</option>
      <option value="lego">Lego</option>
    </select>
  </div>
)}
                 {showAdvanced && useCustomFont && (
  <>
    <div className="form-group">
      <div className="topic">Select Font Color</div>
      <select
        className="input_3"
        value={selectfontcolor}
        onChange={(e) => setselectfontcolor(e.target.value)}
      >
        <option value="#FFFFFF">White</option>
        <option value="#000000">Black</option>
        <option value="#FF0000">Red</option>
        <option value="#00FF00">Green</option>
        <option value="#0000FF">Blue</option>
        <option value="#FFFF00">Yellow</option>
        <option value="#00FFFF">Cyan</option>
        <option value="#FF00FF">Magenta</option>
        <option value="#808080">Gray</option>
        <option value="#FFA500">Orange</option>
      </select>
    </div>

    <div className="form-group">
      <div className="topic">Select Text Style</div>
      <select
        className="input_3"
        value={selectTextStyle}
        onChange={(e) => setSelectTextStyle(e.target.value)}
      >
        <option value="Default">Default</option>
        <option value="Text With Border">Text With Border</option>
        <option value="Text Inside Dark Box">Text Inside Dark Box</option>
        <option value="Text Inside Light Box">Text Inside Light Box</option>
        <option value="Bulb Text">Bulb Text</option>
        <option value="Lime Text">Lime Text</option>
        <option value="Neon Text">Neon Text</option>
        <option value="Text with Shadow">Text with Shadow</option>
        <option value="Slay">Slay</option>
        <option value="Kitty">Kitty</option>
        <option value="Hustle">Hustle</option>
        <option value="Grape">Grape</option>
        <option value="Sprout">Sprout</option>
        <option value="Snuggle">Snuggle</option>
        <option value="Mint">Mint</option>
        <option value="Rizz">Rizz</option>
        <option value="Boba">Boba</option>
        <option value="Matcha">Matcha</option>
        <option value="Boo">Boo</option>
      </select>
    </div>
  </>
)}
               

                  <div className="form-group">
                    <div className="topic">Select Music</div>
                    <div className="music-dropdown-container_backgroundmusic">
                      <div
                        ref={dropdownRef}
                        className="dropdown_backgroundmusic"
                      >
                        <button
                          className="dropdown-btn_backgroundmusic"
                          onClick={() => setDropdownOpen(!dropdownOpen)}
                        >
                          {currentSong ? currentSong.name : "None"}
                        </button>
                        {dropdownOpen && (
                          <div className="dropdown-content_backgroundmusic">
                            <div
                              className="dropdown-item_backgroundmusic"
                              onClick={handleNoMusicClick}
                            >
                              None
                            </div>
                            {songs.length === 0 ? (
                              <div>Loading...</div>
                            ) : (
                              songs.map((song) => (
                                <div
                                  className="dropdown-item_backgroundmusic"
                                  key={song.file}
                                  onClick={() => handleSongClick(song)}
                                >
                                  {song.name}
                                  <div
                                    className={`play-pause-btn_backgroundmusic ${
                                      playing && currentSong?.file === song.file
                                        ? "pause"
                                        : "play"
                                    }`}
                                    onClick={(e) => togglePlayPause(song, e)}
                                  >
                                    {playing && currentSong?.file === song.file
                                      ? "❚❚"
                                      : "►"}
                                  </div>
                                </div>
                              ))
                            )}
                          </div>
                        )}
                      </div>
                      <audio ref={audioPlayer} />
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="topic">Select Aspect Ratio </div>
                    <select
                      className="input_3"
                      name="tone"
                      value={selectsize}
                      onChange={(e) => setselectsize(e.target.value)}
                    >
                      <option value="9:16">9:16</option>
                      <option value="16:9">16:9</option>
                    </select>
                  </div>

                 </>
)}
                </div>

               

                <button
                  className="generate_btn"
                  onClick={handleGenerate}
                  disabled={isLoading}
                >
                  Generate Video
                </button>
              </>
            )}

            {activeTab === "history" && <History />}
               <Loader show={isLoading}/>
            <NotificationBar
              visible={showNotification}
              message={notificationMessage}
              onClose={() => setShowNotification(false)}
            />
            
          </div>
        </div>
      </div>
      <FAQ />
    </HelmetProvider>
  );
}

export default App;
